var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18331 9.7998L9.29581 5.50849L8.47914 4.65632L5.18331 8.09545L3.52081 6.36067L2.70414 7.21284L5.18331 9.7998ZM5.99997 13.0868C5.19303 13.0868 4.4347 12.9269 3.72497 12.6071C3.01525 12.2877 2.39789 11.8541 1.87289 11.3063C1.34789 10.7585 0.932364 10.1143 0.626308 9.37371C0.319864 8.63313 0.166641 7.84183 0.166641 6.9998C0.166641 6.15777 0.319864 5.36647 0.626308 4.62589C0.932364 3.88531 1.34789 3.2411 1.87289 2.69328C2.39789 2.14545 3.01525 1.71165 3.72497 1.39189C4.4347 1.07252 5.19303 0.912842 5.99997 0.912842C6.80692 0.912842 7.56525 1.07252 8.27497 1.39189C8.9847 1.71165 9.60206 2.14545 10.1271 2.69328C10.6521 3.2411 11.0676 3.88531 11.3736 4.62589C11.6801 5.36647 11.8333 6.15777 11.8333 6.9998C11.8333 7.84183 11.6801 8.63313 11.3736 9.37371C11.0676 10.1143 10.6521 10.7585 10.1271 11.3063C9.60206 11.8541 8.9847 12.2877 8.27497 12.6071C7.56525 12.9269 6.80692 13.0868 5.99997 13.0868Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.7e1ce9dbc73e98d4397188339633e3d6.svg";
export { ForwardRef as ReactComponent };